import { render } from "./AddEditProductModal.vue?vue&type=template&id=6d7c90ac&scoped=true"
import script from "./AddEditProductModal.vue?vue&type=script&lang=js"
export * from "./AddEditProductModal.vue?vue&type=script&lang=js"

import "./AddEditProductModal.vue?vue&type=style&index=0&id=6d7c90ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7c90ac"]])

export default __exports__